'use strict';

const { UpiModule } = require('./UpiModule');

/**
 * QrModule — deprecated alias for UpiModule, kept so existing imports of
 * `./modules/QrModule` keep working. Use UpiModule (client.upi) instead;
 * generateQr/dynamicQr are inherited unchanged (both now hit the same
 * unified /upi/txn/v1/GenerateQR endpoint — see UpiModule.generateQr).
 * checkQrStatus maps onto UpiModule's upiStatus.
 */
class QrModule extends UpiModule {
  /** @deprecated use upiStatus() */
  checkQrStatus(body)   { return this.upiStatus({ trans_id: body?.orderId ?? body?.trans_id }); }
}

module.exports = { QrModule };
